import { render, staticRenderFns } from "./CampaignAdd.vue?vue&type=template&id=80ee49ce&scoped=true"
import script from "./CampaignAdd.vue?vue&type=script&lang=js"
export * from "./CampaignAdd.vue?vue&type=script&lang=js"
import style0 from "./CampaignAdd.vue?vue&type=style&index=0&id=80ee49ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ee49ce",
  null
  
)

export default component.exports